import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

// DASHBOARD
const Dashboard = lazy(() => import("../pages/Dashboard"));

// SHOP
const Cart = lazy(() => import("../pages/Shop/Cart"));
const Checkout = lazy(() => import("../pages/Shop/Checkout"));
const OrderForm = lazy(() => import("../pages/Shop/Configurator/OrderForm"));

// FAVORITES AND SAVED CARTS
const SavedCarts = lazy(() => import("../pages/Shop/SavedCarts/SavedCarts"));
const Favorites = lazy(() => import("../pages/Shop/Favorites/Favorites"));

// CUSTOMER CART (salesperson)
const CustomerCart = lazy(() => import("../pages/Shop/CustomerCart"));

// ORDERS
const Orders = lazy(() => import("../pages/Shop/Orders/index"));
const OrderDetail = lazy(() => import("../pages/Shop/Orders/OrderDetail"));
const OrderSuccess = lazy(() => import("../pages/Shop/OrderSuccess"));

// INVOICES
const InvoiceList = lazy(() => import("../pages/Invoices/InvoiceList"));

// USER PROFILE AND SUBACCOUNTS
const UserProfile = lazy(() => import("../pages/Authentication/user-profile"));
const SubAccounts = lazy(() => import("../pages/Authentication/SubAccounts"));
const SalesOffers = lazy(() => import("../pages/Sales/SalesOffers"));

// ADMIN SECTION
const AllOrders = lazy(() => import("../pages/Admin/AllOrders"));
const AllUsers = lazy(() => import("../pages/Admin/AllUsers"));
const PostgresTools = lazy(() => import("../pages/Admin/PostgresTools"));
const DownloadCentreAdmin = lazy(() => import("../pages/Admin/DownloadCentreAdmin"));

// OTHER PAGES
const Handbook = lazy(() => import("../pages/Handbook"));
const DownloadCentre = lazy(() => import("../pages/DownloadCentre/DownloadCentre"));
const News = lazy(() => import("../pages/News/News"));
const ProductionTerms = lazy(() => import("../pages/ProductionTerms"));
const Contact = lazy(() => import("../pages/Pages/Contact/Contact"));
const PrivacyPolicy = lazy(() => import("../pages/Pages/PrivacyPolicy"));

// AUTH
const Login = lazy(() => import("../pages/Authentication/Login"));
const Register = lazy(() => import("../pages/Authentication/Register"));
const RegisterSuccess = lazy(() => import("../pages/Authentication/RegisterSuccess"));
const ForgotPassword = lazy(() => import("../pages/Authentication/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/Authentication/ResetPassword"));

const authProtectedRoutes = [
  { path: "/", component: <Dashboard /> },
  { path: "/index", component: <Dashboard /> },

  { path: "/cart", component: <Cart /> },
  { path: "/checkout", component: <Checkout /> },
  { path: "/order-form", component: <OrderForm /> },

  { path: "/saved-carts", component: <SavedCarts /> },
  { path: "/favorites", component: <Favorites /> },
  { path: "/customer-cart", component: <CustomerCart />, requiredPermissions: ["customer-cart"] },

  { path: "/orders", component: <Orders /> },
  { path: "/order-details/:id", component: <OrderDetail /> },
  { path: "/order-success/:id", component: <OrderSuccess /> },

  { path: "/invoices", component: <InvoiceList /> },

  { path: "/profile", component: <UserProfile /> },
  { path: "/profile/subaccounts", component: <SubAccounts />, requiredPermissions: ["subaccounts"] },
  { path: "/sales-offers", component: <SalesOffers viewMode="client" /> },
  { path: "/sales-offers/client", component: <SalesOffers viewMode="client" /> },
  { path: "/sales-offers/sales", component: <SalesOffers viewMode="sales" /> },
  { path: "/sales-offers/admin", component: <SalesOffers viewMode="admin" /> },

  { path: "/all-users", component: <AllUsers />, requiredPermissions: ["users"] },
  { path: "/all-orders", component: <AllOrders />, requiredPermissions: ["all-orders"] },
  { path: "/postgres-tools", component: <PostgresTools /> },
  { path: "/admin/download-centre", component: <DownloadCentreAdmin />, requiredPermissions: ["download-centre"] },

  { path: "/download-centre", component: <DownloadCentre /> },
  { path: "/news", component: <News /> },
  { path: "/production-terms", component: <ProductionTerms /> },
  { path: "/contact", component: <Contact /> },
  { path: "/handbook", component: <Handbook /> },

  { path: "/", exact: true, component: <Dashboard /> },
  { path: "*", component: <Navigate to="/" /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },
  { path: "/register-success", component: <RegisterSuccess /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
];

export { authProtectedRoutes, publicRoutes };
